/**
 * One UTC parse for a D1 timestamp column (#2054).
 *
 * SQLite's `datetime('now')` writes "YYYY-MM-DD HH:MM:SS": a space instead of
 * the T, and no zone. That is outside the ECMA-262 Date Time String Format,
 * so every reader has to normalise it, and any two readers that normalise it
 * differently disagree about when the row was written. Normalise once here,
 * then hand the SAME string to every consumer (a title attribute, timeAgo, a
 * chart axis).
 *
 * Columns written by JS (`new Date().toISOString()`) already carry the T and
 * the Z and pass through untouched, as do offsets like +10:00.
 */

const SQLITE_SPACE_FORM = /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2}(?:\.\d+)?)$/;

/** The value as an unambiguous UTC instant string, or unchanged if it is not the space form. */
export function d1Utc(value: string): string {
  const m = SQLITE_SPACE_FORM.exec(value ?? "");
  return m ? `${m[1]}T${m[2]}Z` : (value ?? "");
}

/** The same instant as a Date. Invalid input yields an Invalid Date, never a guess. */
export function d1Date(value: string): Date {
  return new Date(d1Utc(value));
}
